<template lang="pug">
.v-input-wrapper
  .v-input(:class="[classes, { 'v-input--has-value': hasValue, 'v-input--focused': isFocused }]")
    template(v-if="!isDatePicker")
      input.v-input__field(
        v-focus="focus"
        type="text"
        :value="value"
        :disabled="disabled"
        :autocomplete="autocomplete"
        :pattern="pattern"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur")
    template(v-else)
      slot(
        name="date-picker"
        v-bind="{ isDatePicker }")
    label.v-input__label(:class="{ 'v-input__label--active': isFocused || hasValue || isVisiblePopover || labelActive }") {{ label }}
    .v-input__bar(:class="focusBar")
    .v-input__icon.v-input__icon--right(
      :class="focusIcon")
      slot(name="icon-right")
  .v-input__hint-wrapper
    .v-input__hint(v-if="hint") {{ hint }}
</template>

<script>
export default {
  name: 'VTextField',

  props: {
    label: String,
    value: [String, Number],
    disabled: Boolean,
    autocomplete: {
      type: String,
      default: 'off'
    },
    isDatePicker: {
      type: Boolean,
      default: false
    },
    pattern: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    },
    isVisiblePopover: Boolean,
    focus: {
      type: Boolean,
      default: false
    },
    labelActive: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isFocused: false
    }
  },

  computed: {
    classes () {
      return {
        'v-input--invalid': this.invalid
      }
    },
    focusBar () {
      return {
        'v-input__bar--focus': this.isDatePicker && this.isVisiblePopover
      }
    },
    focusIcon () {
      return {
        'v-input__icon--focus': this.isVisiblePopover
      }
    },
    hasValue () {
      return this.value !== null && this.value !== '' && this.value !== undefined
    }
  },

  methods: {
    onInput (e) {
      this.$emit('input', e.target.value)
    },

    onFocus () {
      this.isFocused = true
    },

    onBlur () {
      this.isFocused = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.v-input-wrapper {
  padding-top: 2.5rem;
}

.v-input {
  position: relative;

  &__hint-wrapper {
    min-height: 1.5rem;
  }

  &__hint {
    color: $color-red;
    font-size: 1.2rem;
    font-weight: 300;
  }

  &--invalid {
    label {
      color: $color-red !important;
    }

    .v-input__field {
      color: $color-red !important;
      border: .2rem solid $color-red !important;
    }

    .v-input__bar:before,
    .v-input__bar:after {
      background-color: transparent !important;
    }
  }

  &__field {
    position: relative;
    cursor: text;
    display: flex;
    justify-content: space-between;
    font-size: 1.5rem;
    width: 100%;
    height: 4rem;
    padding: 1rem;
    border-radius: 1rem;
    background: $color-hover;
    border: none;
    transition: background-color 0.2s ease;

    &:focus {
      outline: none;
    }

    &:focus ~ .v-input__icon {
      color: $color-black;
    }

    &:disabled ~ label {
      color: $color-gray-light;
    }

    &:focus ~ .v-input__bar:before,
    &:focus ~ .v-input__bar:after {
      width: 50%;
    }
  }

  &__label {
    color: $color-black;
    font-size: 1.5rem;
    position: absolute;
    pointer-events: none;
    line-height: 1.3rem;
    top: 1.2rem;
    left: 1rem;
    transition: 0.2s ease all;

    &--active {
      top: -2.2rem !important;
      left: 0 !important;
      font-size: 1.3rem !important;
      color: $color-gray !important;
    }
  }

  &__icon {
    position: absolute;
    top: 0;
    height: 100%;
    width: 3rem;
    font-size: 2rem;
    color: $color-gray;
    display: flex;
    align-items: center;
    justify-content: center;

    &--focus {
      color: $color-black;
    }

    &--right {
      right: 0;
    }
  }

  &--has-value {
    .v-input__field {
      background-color: #F4F4F4;
    }
  }

  &--focused {
    .v-input__field {
      background-color: #DDF2E3;
    }
  }
}
</style>